// extracted by mini-css-extract-plugin
export default {"cls1":"t5joqhBARbQvlb9dT_CZ","cls2":"kPB5a9DG6wx_INFTzup9 t5joqhBARbQvlb9dT_CZ"};